import { ContainerUsageStatus, ContainerStatus, ContainerOccupancyStatus, ContainerSortField, SortOrder } from '../types/container';

// Container usage status options
export const CONTAINER_USAGE_STATUS_OPTIONS = [
  { value: 'all', label: '全部' },
  { value: 'ENABLE' as ContainerUsageStatus, label: '启用' },
  { value: 'DISABLE' as ContainerUsageStatus, label: '禁用' },
];

// Container status options
export const CONTAINER_STATUS_OPTIONS = [
  { value: 'all', label: '全部' },
  { value: 'ENABLE' as ContainerStatus, label: '启用' },
  { value: 'DISABLE' as ContainerStatus, label: '禁用' },
];

// Container occupancy status options
export const CONTAINER_OCCUPANCY_STATUS_OPTIONS = [
  { value: 'all', label: '全部' },
  { value: 'OCCUPIED' as ContainerOccupancyStatus, label: '已占用' },
  { value: 'AVAILABLE' as ContainerOccupancyStatus, label: '可用' },
];

// Pagination options for container list
export const CONTAINER_PAGE_SIZES = [20, 50, 100];
export const CONTAINER_DEFAULT_PAGE_SIZE = 100;

// Default pagination settings for containers
export const CONTAINER_PAGINATION_DEFAULT = {
  currentPage: 1,
  pageSize: CONTAINER_DEFAULT_PAGE_SIZE,
  sortBy: 'gmtModified' as ContainerSortField,
  sortOrder: 'desc' as SortOrder,
};

// Container validation rules
export const CONTAINER_VALIDATION_RULES = {
  code: {
    required: false, // Auto-generated for create
    pattern: /^[A-Za-z0-9.-]{1,50}$/,
    message: '托盘编码只能包含字母、数字、点号和横线，长度不超过50个字符',
  },
  name: {
    required: true,
    max: 100,
    message: '托盘名称为必填项，长度不能超过100个字符',
  },
  usageStatus: {
    required: true,
    message: '请选择使用状态',
  },
  status: {
    required: true,
    message: '请选择状态',
  },
  remark: {
    max: 500,
    message: '备注长度不能超过500个字符',
  },
};

// Table column widths for container table
export const CONTAINER_COLUMN_WIDTHS = {
  CODE: 150,
  NAME: 200,
  USAGE_STATUS: 100,
  STATUS: 100,
  OCCUPANT_NAME: 120,
  OCCUPY_TASK_CODE: 150,
  OCCUPY_TASK_TYPE: 120,
  GMT_CREATE: 180,
  GMT_MODIFIED: 180,
  ACTIONS: 120,
};

// Status colors for container status display
export const CONTAINER_STATUS_COLORS = {
  ENABLE: '#52c41a',    // Green for enabled
  DISABLE: '#ff4d4f',   // Red for disabled
};

// Usage status colors
export const CONTAINER_USAGE_STATUS_COLORS = {
  ENABLE: '#52c41a',    // Green for enabled
  DISABLE: '#ff4d4f',   // Red for disabled
};

// Occupancy status colors
export const CONTAINER_OCCUPANCY_STATUS_COLORS = {
  OCCUPIED: '#faad14',  // Orange for occupied
  AVAILABLE: '#52c41a', // Green for available
};

// Process definition key for container creation
export const CONTAINER_PROCESS_DEF_KEY = 'wms.base-data.container.custom.create';

// Default values for container creation
export const CONTAINER_CREATE_DEFAULTS = {
  prefixUseSpecCode: 'true',
  quantity: 1,
  processDefKey: CONTAINER_PROCESS_DEF_KEY,
};


// Add NO_SELECTED to CONTAINER_MESSAGES for backward compatibility
export const CONTAINER_MESSAGES = {
  CREATE_SUCCESS: '托盘创建成功',
  UPDATE_SUCCESS: '托盘更新成功',
  DELETE_SUCCESS: '托盘删除成功',
  BATCH_UPDATE_SUCCESS: '批量操作成功',
  CREATE_CONFIRM: '确认创建托盘？',
  UPDATE_CONFIRM: '确认更新托盘信息？',
  DELETE_CONFIRM: '确认删除托盘？此操作不可恢复。',
  BATCH_ENABLE_CONFIRM: '确认批量启用选中的托盘？',
  BATCH_DISABLE_CONFIRM: '确认批量禁用选中的托盘？',
  NO_DATA: '暂无数据',
  LOADING: '加载中...',
  NETWORK_ERROR: '网络连接异常，请检查网络后重试',
  SERVER_ERROR: '服务器异常，请稍后重试',
  PERMISSION_ERROR: '权限不足，请联系管理员',
  VALIDATION_ERROR: '数据验证失败，请检查输入内容',
  CODE_DUPLICATE_ERROR: '托盘编码已存在，请使用其他编码',
  OCCUPIED_DELETE_ERROR: '托盘已被占用，无法删除',
  OCCUPIED_DISABLE_ERROR: '托盘已被占用，无法禁用',
  NO_SELECTED: '请选择要操作的托盘',
};

// Breadcrumb texts
export const CONTAINER_BREADCRUMBS = {
  HOME: '首页',
  CONTAINER_MANAGEMENT: '托盘管理',
  CONTAINER_LIST: '托盘列表',
  CONTAINER_DETAIL: '托盘详情',
  CONTAINER_CREATE: '新增托盘',
  CONTAINER_EDIT: '编辑托盘',
};